import { useMemo } from 'react';
import { docentes, type Docente } from '@/data/docentes';
import styles from './DocentesList.module.css';

const PARTICULAS = new Set(['de', 'la', 'las', 'los', 'del', 'y', 'da', 'do']);

const formatApellido = (apellido: string): string =>
  apellido
    .split(' ')
    .map((palabra) =>
      PARTICULAS.has(palabra.toLowerCase()) ? palabra.toLowerCase() : palabra,
    )
    .join(' ');

const formatDocente = (docente: Docente): string => {
  const iniciales = docente.nombre
    .split(' ')
    .filter(Boolean)
    .map((palabra) => `${palabra.charAt(0).toUpperCase()}.`)
    .join(' ');

  return `${iniciales} ${formatApellido(docente.apellido)}`.trim();
};

export const DocentesList: React.FC = () => {
  const sortedDocentes = useMemo(() => {
    return [...docentes].sort((a, b) => {
      const orderA = a.orden ?? Number.MAX_SAFE_INTEGER;
      const orderB = b.orden ?? Number.MAX_SAFE_INTEGER;
      if (orderA !== orderB) {
        return orderA - orderB;
      }
      return a.apellido.localeCompare(b.apellido, 'es');
    });
  }, []);

  return (
    <section className={styles.section}>
      <div className={styles.header}>
        <h3 className={styles.title}>Plantel Docente</h3>
      </div>

      <p className={styles.citation}>
        {sortedDocentes.map(formatDocente).join(', ')}.
      </p>
    </section>
  );
};
